import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=12088839"
import script from "./Blogs.vue?vue&type=script&lang=ts"
export * from "./Blogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports